import Icon from '../components/Icon.vue'

Icon.register({
  igloo: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M320 33.9C309.5 32.7 298.8 32 288 32 188.2 32 100.2 82.8 48.6 160H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320H96V192zM352 39.4V160H527.4C487.2 99.9 424.8 55.9 352 39.4zM480 320H576C576 274 564.9 230.6 545.7 192H480V320zM416 384V480H544C561.7 480 576 465.7 576 448V352H411.5C414.1 362.3 416 372.9 416 384zM448 192H128V320H177.8C200 281.9 240.8 256 288 256S376 281.9 398.2 320H448V192zM0 448C0 465.7 14.3 480 32 480H160V384C160 372.9 161.9 362.3 164.5 352H0V448zM288 288C235 288 192 331 192 384V480H384V384C384 331 341 288 288 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/igloo.js
// module id = O1BP
// module chunks = 144